module.exports = __webpack_public_path__ + "img/bg03.ed2a1b5e.jpg";